import { useEffect, useState } from "react";

import {
  emptyView,
  resolvePregnancyView,
  views,
} from "./resolvePregnancyView.js";

export { views };

export const useView = (pregnancies) => {
  const [storedView, setStoredView] = useState(() =>
    resolvePregnancyView(emptyView, pregnancies)
  );

  // Derived on every render, so no frame can be rendered with a pregnancyId the list no longer
  // holds — the stored state is only ever caught up afterwards (KIN-2047).
  const view = resolvePregnancyView(storedView, pregnancies);

  useEffect(() => {
    if (view !== storedView) {
      setStoredView(view);
    }
  }, [view, storedView]);

  return [view, setStoredView];
};
